<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="400px">
      <v-card>
        <v-card-title class="justify-center">Factura</v-card-title>

        <v-divider></v-divider>
        <br />

        <v-card-text class="text-center">
          <v-spacer></v-spacer>
          <v-form ref="facturaForm">
            <Factura ref="facturaRef" />
          </v-form>
        </v-card-text>
        <v-card-actions>
          <div class="row justify-center pb-5 mt-5">
            <v-btn
              v-if="!loading"
              color="light"
              text
              style="height: 50px; width: 50px"
              @click="goBack"
            >
              <font-awesome-icon
                icon="arrow-circle-left"
                :style="{ color: '#000000', fontSize: 50 }"
              />
            </v-btn>
            <v-btn
              v-if="!loading"
              color="light"
              text
              style="height: 50px; width: 50px"
              @click="
                dialog = false;
                clear();
              "
            >
              <font-awesome-icon
                icon="times-circle"
                :style="{ color: '#ea2222', fontSize: 50 }"
              />
            </v-btn>

            <v-btn
              v-if="!loading"
              color="light"
              text
              style="height: 50px; width: 50px"
              @click="pay"
            >
              <font-awesome-icon
                icon="check-circle"
                :style="{ color: '#11bd11', fontSize: 50 }"
              />
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import firebaseMixin from "@/mixins/firebase/firebaseMixin";
import Factura from "./Factura";

export default {
  name: "facturaDetail",
  mixins: [firebaseMixin],
  components: {
    Factura
  },
  data() {
    return {
      dialog: false,
      loading: false,
      amount: 0,
      dividePayment: "",
      selectedProducts: [],
      payment: "",
      orders: []
    };
  },
  methods: {
    openDialog({ amount, dividePayment, selectedProducts, payment }) {
      console.log(amount, dividePayment, selectedProducts, payment);
      this.amount = amount;
      this.dividePayment = dividePayment;
      this.selectedProducts = selectedProducts;
      this.payment = payment;
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    },
    goBack() {
      this.$emit("back", this.payment);
      this.dialog = false;
    },
    pay() {
      if (this.$refs.facturaForm.validate()) {
        this.$emit("pay", {
          amount: this.amount,
          dividePayment: this.dividePayment,
          selectedProducts: this.selectedProducts,
          payment: this.payment,
          invoiceRequest: true,
          company: { ...this.$refs.facturaRef.company }
        });
        this.clear();
      }
    },
    clear() {
      this.$refs.facturaRef.invoiceRequest = false;
      this.$refs.facturaForm.reset();
      this.dialog = false;
    }
  }
};
</script>
